import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DropdownOptions from "../../../constants/DropdownOptions";
import { counterpartyListAction,getOnboardcounterpartyListAction,updateRequest, deleteCounterPartyAction, editCounterPartyAction } from "../../../modules/counterparties/action";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import TabHeaderAndButton from "../../Common/TabHeaderAndButton";
import InviteButtonTabHeader from "../../Common/InviteButtonTabHeader"
import CreateTable from "../../CreateTable";
import ConfirmationDialog from "../../FormElement/ConfirmationDialog";
import Loader from "../../Loader";
import CustomTooltip from "../../../utils/CustomTooltip";
import SimpleSnackbar from '../../../../src/components/SimpleSnackbar';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import pending from './../../../assets/images/circular-clock.png'
import cancel from "./../../../assets/images/cloud-computing.png"
import connects from "./../../../assets/images/link.png"
import InputFiled from "../../FormElement/InputFiled";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
class CounterpartiesView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      orderfetchingComplete: false,
      dialogopen:false,
      headerRows: {
        updatedAt: "Last Updated",
        updatedBy: "Updated By",
        type: "Type",
        name: "Counterpart",
        phoneNumber: "Contact Phone Number"
      },
      orderheaderRows: {
        counterPartyName: "Counterparty Name",
        counterpartyMemberName: "Counterparty Member",
        counterPartyTypeEnum: "Type",
        connectionStatusEnum: "Status",
        connectionStatusAction: "Action",
      },
      orderRowDataState:this.props.orderRowData || [],
      order: "desc",
      orderRowDataId:1,
      orderBy: "id",
      dialogText:'',
      diaogButtonText:'',
      searchValue:''
    };
  }

  componentDidMount() {
    const { counterpartyListAction, selectedYear, getOnboardcounterpartyListAction } = this.props;
    if(!isSuperAdmin() || this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
      counterpartyListAction(selectedYear);
      getOnboardcounterpartyListAction()
      setTimeout(()=>{
       this.setState({orderRowDataState:this.props.orderRowData })
      },1500)
    }
  }
  handleInvite = () =>{
    const { counterpartyListAction, selectedYear, getOnboardcounterpartyListAction } = this.props;
      setTimeout(()=>{
        getOnboardcounterpartyListAction()
      },1500)
      setTimeout(()=>{
       this.setState({orderRowDataState:this.props.orderRowData })
      },2000)
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.rowData &&
      this.props.rowData !== nextProps.rowData &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
      console.log('rowdata1')
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      console.log('rowdata')
      this.setState({ fetchingComplete: true });
    }




    if (
      nextProps.orderRowData &&
      this.props.orderRowData !== nextProps.orderRowData &&
      this.state.orderfetchingComplete === false
    ) {
      this.setState({ orderfetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      console.log('orderrowdata')
      this.setState({ orderfetchingComplete: true });
    }



    if (this.props.MainFarmId !== nextProps.MainFarmId &&
      nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
        this.props.counterpartyListAction(this.props.selectedYear);
      }
    if (nextProps.selectedYear && nextProps.selectedYear !== this.props.selectedYear &&
      (!isSuperAdmin() || nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id)) {
      this.props.counterpartyListAction(nextProps.selectedYear);
    }
  }

  deleteRow = id => {
    this.setState({
      open: true,
      id: id
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOk = () => {
    const { id } = this.state;
    this.handleClose();
    this.props.deleteCounterPartyAction(id);
  };

  editRow = id => {
    const { rowData } = this.props;
    const requiredData = rowData.find(counterParty => counterParty.id === id);
    this.props.editCounterPartyAction(requiredData);
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };
  handleOpenDealog = (text, buttonText,payload) => {
    this.setState({ dialogText: text });
    this.setState({ payloadData: payload });
    this.setState({ diaogButtonText: buttonText });
    this.setState({ dialogopen: true });
  }
  finalsubmit = (payload) => {
    this.props.updateRequest(payload)
    setTimeout(()=>{
      this.setState({orderRowDataState:this.props.orderRowData })
    },1500)
  }

  convertorder = row => {
    let temp = row;
    for (let i = 0; i < temp.length; i++) {
      temp[i].counterPartyName = <span style={{display:'flex',gap:'10px',alignItems:'center'}}>{temp[i].counterPartyName}{!temp[i].paymentStatus && typeof temp[i].counterPartyName==="string" && <CustomTooltip
      title={"Counterparty Subscription Invalid"}
      ariaLabel="connect"
    ><span style={{fontSize:'20px'}}>⚠️</span></CustomTooltip>}</span>
      if (temp[i].connectionStatusEnum === "REQUEST_SENT" || (temp[i].connectionStatusEnum && temp[i].connectionStatusEnum.props &&(temp[i].connectionStatusEnum.props.children==="Request Sent"))) {
        temp[i].connectionStatusEnum = <div className="requestChip">Request Sent</div>
        temp[i].connectionStatusAction = <CustomTooltip
        title={"Pending"}
        ariaLabel="connect"
      ><img  src={pending}  width={35} alt="view" onClick={()=>this.handleOpenDealog("Are you sure you want to cancel this connection request?","CONFIRM",{
          "connectionStatusEnum": "REQUEST_CANCELLED_BY_SENDER",
          "otherUserId": temp[i].counterPartyUserId
      })}/></CustomTooltip>
      }
      else if(temp[i].connectionStatusEnum === "CONNECTED"|| (temp[i].connectionStatusEnum && temp[i].connectionStatusEnum.props &&(temp[i].connectionStatusEnum.props.ariaLabel==="connect"))){
        temp[i].connectionStatusEnum = <CustomTooltip
        title={temp[i].timeStamp || "Connected few mins ago"}
        ariaLabel="connect"
      ><span className="connectedChip">Connected</span></CustomTooltip>
      temp[i].connectionStatusAction = <CustomTooltip
      title={"Cancel Connection"}
      ariaLabel="connect"
    ><img  src={cancel}  width={35} alt="view" onClick={()=>this.handleOpenDealog(`Are you sure you want to disconnect ${temp[i].counterpartyMemberName}?`,"CONFIRM",{
        "connectionStatusEnum": "CONNECTION_REMOVED_BY_SENDER",
        "otherUserId": temp[i].counterPartyUserId
    })} /></CustomTooltip>
      }
      else{
        temp[i].connectionStatusEnum = <span> </span>
        temp[i].connectionStatusAction =  <CustomTooltip
        title={"Connect"}
        ariaLabel="connect"
      ><img  src={connects}  width={35} alt="view"  onClick={()=>this.handleOpenDealog(` Are you sure you want to send connection request to ${temp[i].counterpartyMemberName}?`,"SEND INVITATION",{
          "connectionStatusEnum": "REQUEST_SENT",
          "otherUserId": temp[i].counterPartyUserId
      })}/></CustomTooltip>
      }
    }
    return temp;
  }
  handleClose = () => {
    this.setState({ dialogopen: false });
    this.setState({open:false})
  };
  handleNextPage = (page, rowsPerPage) => {
  this.setState({orderRowDataId:page+1})
  };
  handleSearch = (value) => {
    let temp = []
    for(let i = 0;i<this.props.orderRowData.length;i++){

      if(typeof this.props.orderRowData[i].counterpartyMemberName==='object'){

        if((this.props.orderRowData[i].counterpartyMemberName && this.props.orderRowData[i].counterpartyMemberName.props.children[0] && this.props.orderRowData[i].counterpartyMemberName.props.children[0].toLowerCase().includes(value.toLowerCase()))){
          temp.push(this.props.orderRowData[i].counterpartyMemberName.props.children[0])
        }
      }
      else if((this.props.orderRowData[i].counterpartyMemberName && this.props.orderRowData[i].counterpartyMemberName.toLowerCase().includes(value.toLowerCase()))){
        temp.push(this.props.orderRowData[i])
      }
    }
    this.setState({orderRowDataState:[...temp]})
    this.setState({searchValue:value})

  }
  render() {
    const { rowData, orderRowData } = this.props;
    const { fetchingComplete, order, orderBy, open, dialogText, diaogButtonText, payloadData,orderRowDataId, orderRowDataState, searchValue, orderfetchingComplete } = this.state;
    const prevPath = "farmsetup",
      currentPage = "/counterparties";
    return (
      <div className="ticket-body">
          <Dialog open={this.state.dialogopen} onClose={() =>this.handleClose()} aria-labelledby="form-dialog-title">
        <DialogContent>
         {dialogText}
         
        </DialogContent>
        <DialogActions>
          <button onClick={() =>this.handleClose()} className={diaogButtonText==="SEND INVITATION"?"reject":"green"} color="primary">
            CANCEL
          </button>
          <button className={diaogButtonText==="CONFIRM"?"reject":"green"} onClick={()=>{this.finalsubmit(payloadData);
           this.handleClose()}} color="primary">
            {diaogButtonText}
          </button>
        </DialogActions>
      </Dialog>
         <SimpleSnackbar />
        <ConfirmationDialog
          open={open}
          handleClose={this.handleClose}
          handleOk={this.handleOk}
        />
        <TabHeaderAndButton
          header="Custom Counterparties"
          path={`/${prevPath}${currentPage}/create`}
          btnLabel="New counterpart"
          isDisabled={isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id}
        />
        {isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? 
        (<AllMainFarmSelectedDialog/>) : 
        (
          <div>
            {fetchingComplete ? (
              <CreateTable
                order={order}
                orderBy={orderBy}
                headerRows={this.state.headerRows}
                rowData={rowData}
                delete={this.deleteRow}
                location={`${prevPath}${currentPage}/edit`}
                edit={this.editRow}
                onRequestSort={this.handleRequestSort}
              />
            ) : (
              <Loader />
            )}
          </div>
        )}
        <InviteButtonTabHeader
          header="Member Counterparties"
          path={`/${prevPath}${currentPage}/create`}
          btnLabel="Invite CounterParty"
          isDisabled={isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id}
          handleSubmit= {this.handleInvite}
        />
        <div class="search-bar">
          <InputFiled
              value={searchValue}
              placeholder="Search Counterparty Member..."
              handleChange={(e)=>this.handleSearch(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
            />
            </div>
{/* <div class="search-bar">
  <input type="search" id="search-input" placeholder="Search Counterparty Member..." value={searchValue} onChange={(e)=>this.handleSearch(e.target.value)}/>
</div>         */}
 <div>
            {orderfetchingComplete ? (
              <CreateTable
                order={order}
                orderBy={orderBy}
                headerRows={this.state.orderheaderRows}
                rowData={this.convertorder(orderRowDataState.slice((orderRowDataId-1)*10,orderRowDataId*10))}
                delete={this.deleteRow}
                location={`${prevPath}${currentPage}/edit`}
                edit={this.editRow}
                onRequestSort={this.handleRequestSort}
                isMenuRequired={false}
                handleNextPage={this.handleNextPage}
                totalElements={orderRowDataState.length}
                rowsPerPage={10}
              />
             ) : (
              <Loader />
            )} 
          </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowData: state.counterPartyReducer.counterPartyList,
    orderFetchComplete: state.counterPartyReducer.orderFetchComplete,
    orderRowData :state.counterPartyReducer.onboardCounterPartyList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      counterpartyListAction,
      getOnboardcounterpartyListAction,
      deleteCounterPartyAction,
      editCounterPartyAction,
      updateRequest
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CounterpartiesView);



// WEBPACK FOOTER //
// ./src/components/private/Counterparties/CounterpartiesView.js